// [목적] 신고(report) 도메인 zod 스키마 — POST /reports 요청/응답 BE/FE 공유
// [이유] M9 P2 신고·금칙어 Spec — infra/db/ddl/50_community.sql reports 테이블(target_kind CHECK:
//         portfolio|comment|user|poi, status CHECK: open|resolved|rejected|escalated)에 맞춰 앱 레벨
//         targetType(folio|comment|user)·reason enum 을 정의한다. DDL 은 reason 에 CHECK 제약이 없어
//         이 enum 이 유일한 값 검증 소스다(운영 정책 재조정 시 이 배열만 갱신하면 됨).
// [사이드 이팩트] apps/api ReportsController 입력 검증 + apps/web 신고 폼(향후 연결) 양쪽에서 재사용 가능.
//               targetType='folio' 는 서비스 계층에서 DB target_kind='portfolio' 로 매핑된다(BE 전용, 이 파일은
//               앱 레벨 이름만 정의).
// [수정 시 고려사항] reason 값 추가/삭제 시 서비스단 매핑 불필요(그대로 DB reason text 컬럼에 저장).
//                   poi 타입 신고는 이번 범위 밖(admin.repository.ts 의 poi.REPORT_DUPLICATE 슬롯은 별도 기능).

import { z } from 'zod';

// festival-comments Spec D-6: 'festivalComment' → DB target_kind='festival_comment'(폴리오 댓글 'comment' 와 대상 테이블이 달라 분리)
export const reportTargetTypeEnum = z.enum(['folio', 'comment', 'user', 'festivalComment']);
export const reportReasonEnum = z.enum(['spam', 'abuse', 'inappropriate', 'other']);
export const reportStatusEnum = z.enum(['open', 'resolved', 'rejected', 'escalated']);

/** POST /reports 요청 body */
export const createReportSchema = z.object({
  targetType: reportTargetTypeEnum,
  targetId: z.string().uuid(),
  reason: reportReasonEnum,
  detail: z.string().max(1000).optional(),
});

/** POST /reports 응답 data */
export const reportSchema = z.object({
  id: z.string().uuid(),
  targetType: reportTargetTypeEnum,
  targetId: z.string().uuid(),
  reason: reportReasonEnum,
  detail: z.string().nullable(),
  status: reportStatusEnum,
  createdAt: z.string(),
});

export type ReportTargetType = z.infer<typeof reportTargetTypeEnum>;
export type ReportReason = z.infer<typeof reportReasonEnum>;
export type ReportStatus = z.infer<typeof reportStatusEnum>;
export type CreateReportInput = z.infer<typeof createReportSchema>;
export type Report = z.infer<typeof reportSchema>;
